import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  SubtextSemantic_getInstance1duu1ll1kgx8d as SubtextSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H1Semantic28sytsa4fm6nk as get_H1Semantic,
  CompactSemantic_getInstance3lxnpjuev524m as CompactSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  themed2vu67ornd4jps as themed,
  get_bold3d63kt1t4c9r5 as get_bold,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
  Link$_get_to_$ref_jq7esp1qhuglz6kwpan as Link$_get_to_$ref_jq7esp,
  Link$_set_to_$ref_i9gu5xmkiv49juwaf as Link$_set_to_$ref_i9gu5x,
} from '../../App.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { NewGrantRatePagekivqkap2rvng as NewGrantRatePage } from './NewGrantRatePage.mjs';
import {
  ExcelLikeFormula3nl4zwq7og62 as ExcelLikeFormula,
  _ExcelLikeFormula___get_string__impl__klk7ep2db4efrd7vvyv as _ExcelLikeFormula___get_string__impl__klk7ep,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excel.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_centered31th09q7x90sf as get_centered,
  get_atBottomStart1iulwjfo1udg3 as get_atBottomStart,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  CareDayInfoWithEmployerSubsidybae42h7dxu4n as CareDayInfoWithEmployerSubsidy,
  CareDayInfoWithSubsidies1r6eshq91lm1r as CareDayInfoWithSubsidies,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/excelInputs.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { default1jaun537xukbl as default_0 } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Defaults.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { formulaViewer2404fzigtyleo as formulaViewer } from '../components/formulaTester.mjs';
import {
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { Formjae7dnqjclc3 as Form } from '../components/form.mjs';
import { ID1lyj7m2ox8cp5 as ID } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { Draft3goc8q7vggbic as Draft } from '../../extensions/Draft.ext.mjs';
import { validated2q9ie09qg9r46 as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/ValidatedDraft.mjs';
import { GrantRatevnytkougj5sm as GrantRate } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/subsidyRates.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_grant2comy80he6eab as get_grant,
  get_activeRange1esci1i2m7f7u as get_activeRange,
  get_start30tbw38mnjak0 as get_start,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { eq353yrgcpovoi1 as eq } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import { ReactiveState__getOrNull_impl_1asnfp338k3yl4xmyxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  goBackButton1g9k0xsmfm57i as goBackButton,
  iconButton2nzpucy7a6ixd as iconButton,
  maybeLabel2ow5e5yzodgn0 as maybeLabel,
  reactiveLabel206b3aonybuoa as reactiveLabel,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import {
  Companion_getInstance23x6zslwzj0st as Companion_getInstance_0,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_edit5ty08lpw30d6 as get_edit,
  get_arrowForward16hp7dhxwxirj as get_arrowForward,
} from '../../icons.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  setOf1u3mizs95ngxo as setOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  Cents__toString_impl_ko5hxm1a9pwstsznn43 as Cents__toString_impl_ko5hxm,
  Cents1lsbs5l1tlgw as Cents,
} from '../../../../../../service-abstractions-currency/com/lightningkite/services/data/Cents.mjs';
import { LabelGapSemantic_getInstance2wftjv243mafi as LabelGapSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  LargeTextSemantic_getInstance3ukb2tgj992rz as LargeTextSemantic_getInstance,
  styledHeaderwng1nfqibdig as styledHeader,
  ChipSemantic_getInstancen74y1gyt9zmo as ChipSemantic_getInstance,
} from '../../theme/semantics.mjs';
import { renderToStringprxvmjepz2st as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { Link2eefk0yp041c4 as Link } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Link.commonHtml.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { GrantTransactionsPage3anbgmpp83vih as GrantTransactionsPage } from './GrantTransactionsPage.mjs';
import {
  DayTotalsPage3tkd9ei9dl3us as DayTotalsPage,
  DayGrouping_Family_getInstance13nqmghrlrmsx as DayGrouping_Family_getInstance,
} from '../reports/DayTotalsPage.mjs';
import { ReportFiltersigb451dg4asm as ReportFilters } from '../reports/ReportFilters.mjs';
import { PlacementTotalsPage1pmi1f9h9gb4a as PlacementTotalsPage } from '../reports/PlacementTotalsPage.mjs';
import { SingleDaysPage2w42wjhncrkcq as SingleDaysPage } from '../reports/SingleDaysPage.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import {
  Companion_instance35wmauq2koet0 as Companion_instance_0,
  tablezpetcq9vbay1 as table,
} from '../components/table.mjs';
import { grantForm1udyv5idc0xp6 as grantForm } from './grantComponents.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/CanBlockBack.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function actionBar($this, $receiver) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())($receiver.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $receiver.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_0 = themed(element, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (Button())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextView())(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
  element_1.invoke_bnq13k_k$(tmp_1, GrantDetailPage$actionBar$lambda);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  onClick(element_0, VOID, VOID, VOID, GrantDetailPage$actionBar$slambda($this));
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  var this_1 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (Space())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_1.willAddChild_hz2iwc_k$(element_2);
  element_2.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_2);
  // Inline function 'com.lightningkite.kiteui.views.important' call
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var this_2 = themed(element, ImportantSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  var this_3 = themed(this_2, ButtonSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (Button())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_4, GrantDetailPage$actionBar$lambda_0);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  element_3.set_action_2ds022_k$(Action('Save grant', VOID, VOID, VOID, VOID, VOID, GrantDetailPage$actionBar$slambda_0($this, element_3)));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  $receiver.addChild_2qpft2_k$(element);
}
function GrantDetailPage$grant$lambda($this$Draft) {
  return $this$Draft.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$();
}
function GrantDetailPage$isAdmin$lambda($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function GrantDetailPage$render$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantDetailsHeading_4bpyr7_k$();
}
function GrantDetailPage$render$lambda_0($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function GrantDetailPage$render$lambda_1($this$iconButton) {
  return $this$iconButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantEditButtonDescription_abff03_k$();
}
function GrantDetailPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.grant_1;
    var tmp$ret$0 = yield* await_0(this_0, $completion);
    yield* this$0.addEndDate_1.set_revjhg_k$(!(tmp$ret$0.activeRange_1.endInclusive_1 == null), $completion);
    yield* this$0.editMode_1.set_revjhg_k$(true, $completion);
    return Unit_instance;
  }), 0);
}
function GrantDetailPage$render$lambda_2($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantFunderLabel_2sx24x_k$();
}
function GrantDetailPage$render$lambda_3($this$maybeLabel) {
  return $this$maybeLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantAwardPeriodLabel_m5ymnd_k$();
}
function GrantDetailPage$render$lambda_4($this$reactiveLabel) {
  return $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantBalanceLabel_6ku5mz_k$();
}
function GrantDetailPage$render$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantBalanceLabel_6ku5mz_k$();
}
function GrantDetailPage$render$lambda_6($this$invoke) {
  return 'View ledger';
}
function GrantDetailPage$render$lambda_7($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function GrantDetailPage$render$lambda_8($this$styledHeader) {
  return 'Reports';
}
function GrantDetailPage$render$lambda_9($this$styledHeader) {
  return $this$styledHeader.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantRatesHeading_1jdw1q_k$();
}
function GrantDetailPage$render$lambda_10($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantRatesSubtext_pgb0fh_k$();
}
function GrantDetailPage$render$lambda_11($this$shownWhen) {
  return $this$shownWhen.invoke_r7m7el_k$($this$shownWhen.invoke_r7m7el_k$(get_currentSessionNotNull()).isAdmin_1);
}
function GrantDetailPage$render$lambda_12($this$addButton) {
  return $this$addButton.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantAddNewRateButton_nsc1ss_k$();
}
function GrantDetailPage$render$lambda$slambda_0($this_addButton, this$0) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    get_pageNavigator($this_addButton.get_context_h02k06_k$()).navigate_sm5lxf_k$(new (NewGrantRatePage())(this$0.id_1));
    return Unit_instance;
  }), 1);
}
function GrantDetailPage$render$lambda_13($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateCurrentChip_ej3r0k_k$();
}
function GrantDetailPage$render$lambda_14(it) {
  return new (ExcelLikeFormula())(it.careProvider_1);
}
function GrantDetailPage$render$lambda_15($this$formulaViewer) {
  return $this$formulaViewer.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantShareOfDayLabel_f9y45h_k$();
}
function GrantDetailPage$render$lambda_16(it) {
  return new (ExcelLikeFormula())(it.administration_1);
}
function GrantDetailPage$render$lambda_17($this$formulaViewer) {
  return 'Administration fee';
}
function GrantDetailPage$render$lambda_18($this$table, r) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (Button())($this$table.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$table.willAddChild_hz2iwc_k$(element);
  element.set_action_2ds022_k$(Action('Detail', VOID, VOID, VOID, VOID, VOID, GrantDetailPage$render$lambda$slambda_1(element, r)));
  element.onStartup_vrxh3i_k$();
  $this$table.addChild_2qpft2_k$(element);
  return element;
}
function GrantDetailPage$render$lambda$slambda$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantShareOfDayLabel_f9y45h_k$();
}
function GrantDetailPage$render$lambda$slambda$lambda$lambda_0(it) {
  return new (ExcelLikeFormula())(it.careProvider_1);
}
function GrantDetailPage$render$lambda$slambda$lambda$lambda_1(it) {
  return new (ExcelLikeFormula())(it.administration_1);
}
function GrantDetailPage$render$lambda$slambda_1($$this$button, $r) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp = $$this$button.get_context_h02k06_k$();
    dialog(tmp, VOID, ($this$dialog, it) => {
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var this_0 = sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(50));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_1 = themed(this_0, CardSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
      ensureOutermostElement(element);
      this_1.willAddChild_hz2iwc_k$(element);
      element.set_vertical_nuap32_k$(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_0);
      element.willAddChild_hz2iwc_k$(element_0);
      element_0.set_vertical_nuap32_k$(false);
      // Inline function 'com.lightningkite.kiteui.views.expanding' call
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      var this_2 = weight(element_0, 1.0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_1 = new (Space())(this_2.get_context_h02k06_k$());
      ensureOutermostElement(element_1);
      this_2.willAddChild_hz2iwc_k$(element_1);
      element_1.onStartup_vrxh3i_k$();
      this_2.addChild_2qpft2_k$(element_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      var this_3 = get_centered(element_0);
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_2 = new (TextView())(this_3.get_context_h02k06_k$());
      ensureOutermostElement(element_2);
      this_3.willAddChild_hz2iwc_k$(element_2);
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_2);
      var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_2));
      element_2.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$($r).activeRange_1.toString());
      element_2.onStartup_vrxh3i_k$();
      this_3.addChild_2qpft2_k$(element_2);
      element_0.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_0);
      // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.write' call
      var element_3 = new (TextView())(element.get_context_h02k06_k$());
      ensureOutermostElement(element_3);
      element.willAddChild_hz2iwc_k$(element_3);
      element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_3);
      var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_3));
      element_3.invoke_bnq13k_k$(tmp_4, GrantDetailPage$render$lambda$slambda$lambda$lambda);
      element_3.onStartup_vrxh3i_k$();
      element.addChild_2qpft2_k$(element_3);
      // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaViewer' call
      var formula = lens($r, GrantDetailPage$render$lambda$slambda$lambda$lambda_0);
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_4 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
      var tmp$ret$22 = isInterface(this_4, KSerializer()) ? this_4 : THROW_CCE();
      var testValues = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$22));
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_5 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
      var tmp_5 = isInterface(this_5, KSerializer()) ? this_5 : THROW_CCE();
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_6 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
      var tmp$ret$26 = isInterface(this_6, KSerializer()) ? this_6 : THROW_CCE();
      formulaViewer(element, tmp_5, tmp$ret$26, formula, null, testValues);
      subtext(element, 'Administration fee');
      // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaViewer' call
      var formula_0 = lens($r, GrantDetailPage$render$lambda$slambda$lambda$lambda_1);
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_7 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
      var tmp$ret$29 = isInterface(this_7, KSerializer()) ? this_7 : THROW_CCE();
      var testValues_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$29));
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_8 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
      var tmp_6 = isInterface(this_8, KSerializer()) ? this_8 : THROW_CCE();
      // Inline function 'kotlinx.serialization.serializer' call
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_9 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
      var tmp$ret$33 = isInterface(this_9, KSerializer()) ? this_9 : THROW_CCE();
      formulaViewer(element, tmp_6, tmp$ret$33, formula_0, null, testValues_0);
      element.onStartup_vrxh3i_k$();
      this_1.addChild_2qpft2_k$(element);
      return Unit_instance;
    });
    return Unit_instance;
  }), 1);
}
function GrantDetailPage$render$lambda_19($this$text) {
  return $this$text.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_rateInForceColumnLabel_elll5r_k$();
}
function GrantDetailPage$render$lambda_20($this$text, it) {
  return it.activeRange_1.toString();
}
function GrantDetailPage$render$lambda_21($this$custom) {
  return $this$custom.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantShareColumnLabel_2ddr0u_k$();
}
function GrantDetailPage$render$lambda_22($this$custom, r) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _ExcelLikeFormula___get_string__impl__klk7ep($this$invoke.invoke_r7m7el_k$(r).careProvider_1));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function GrantDetailPage$render$lambda_23($this$custom) {
  return 'Administration';
}
function GrantDetailPage$render$lambda_24($this$custom, r) {
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (TextView())($this$custom.get_context_h02k06_k$());
  ensureOutermostElement(element);
  $this$custom.willAddChild_hz2iwc_k$(element);
  element.set_wraps_9wisy1_k$(false);
  element.set_ellipsis_rhzl3b_k$(true);
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl(element);
  var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element));
  element.invoke_bnq13k_k$(tmp_1, ($this$invoke) => _ExcelLikeFormula___get_string__impl__klk7ep($this$invoke.invoke_r7m7el_k$(r).administration_1));
  element.onStartup_vrxh3i_k$();
  $this$custom.addChild_2qpft2_k$(element);
  return Unit_instance;
}
function GrantDetailPage$render$lambda_25($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
function GrantDetailPage$actionBar$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function GrantDetailPage$actionBar$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    this$0.grant_1.cancel_2l89ey_k$();
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    return Unit_instance;
  }), 0);
}
function GrantDetailPage$actionBar$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantSaveButton_2wxpb6_k$();
}
function GrantDetailPage$actionBar$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues(this$0.grant_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* this$0.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      this$0.formIssuesDialog$default_8ey6bo_k$($$this$button.get_context_h02k06_k$());
      return Unit_instance;
    }
    var tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.addEndDate_1;
    if (!(yield* await_1(this_1, $completion))) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = this$0.grant_1;
      var tmp_1 = yield* await_0(this_2, $completion);
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_3 = this$0.grant_1;
      var tmp$ret$4 = yield* await_0(this_3, $completion);
      tmp_0 = yield* this$0.grant_1.set_revjhg_k$(tmp_1.copy$default_l6uaby_k$(VOID, VOID, VOID, tmp$ret$4.activeRange_1.copy$default_iikz6e_k$(VOID, null)), $completion);
    }
    yield* this$0.grant_1.publish_xq9q2e_k$($completion);
    yield* this$0.editMode_1.set_revjhg_k$(false, $completion);
    var tmp_2 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = get_strings(AppState_getInstance());
    var tmp$ret$5 = yield* await_1(this_4, $completion);
    toast(tmp_2, tmp$ret$5.get_grantSavedToast_ii827n_k$());
    return Unit_instance;
  }), 1);
}
var GrantDetailPageClass;
function GrantDetailPage() {
  if (GrantDetailPageClass === VOID) {
    class $ extends Form() {
      constructor(id) {
        super();
        this.id_1 = id;
        var tmp = this;
        tmp.grant_1 = validated(Draft(new (ID())(this.id_1), GrantDetailPage$grant$lambda));
        var tmp_0 = this;
        tmp_0.rates_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grantRates_6bprq8_k$();
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(GrantRate()), arrayOf([]), false));
          var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$2);
          var tmp_1 = eq(get_grant(it), new (ID())(this.id_1));
          // Inline function 'com.lightningkite.services.database.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_2 = serializerOrContextual(createKType(getKClass(GrantRate()), arrayOf([]), false));
          var tmp$ret$9 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$9);
          this_0.descending_tl4o2_k$(get_start(get_activeRange(it_0)));
          var tmp$ret$5 = this_0.build_1k0s4u_k$();
          return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(new (Query())(tmp_1, tmp$ret$5)));
        });
        var tmp_1 = this;
        tmp_1.currentRate_1 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.invoke_r7m7el_k$(this.rates_1);
          var tmp$ret$11;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.activeRange_1.contains_pio7lx_k$(today())) {
                tmp$ret$11 = element;
                break $l$block;
              }
            }
            tmp$ret$11 = null;
          }
          return tmp$ret$11;
        });
        this.addEndDate_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
        var tmp_2 = this;
        tmp_2.isAdmin_1 = remember(VOID, VOID, VOID, VOID, GrantDetailPage$isAdmin$lambda);
        this.editMode_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(false);
      }
      get_title_iz32un_k$() {
        return remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.grant_1).name_1);
      }
      onNavigateAwayAttempt_vrrtsh_k$() {
        return !(ReactiveState__getOrNull_impl_1asnfp(this.grant_1.get_changesMade_d6j01d_k$().get_state_wc71uu_k$()) === true);
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance().fromParentNonCascading_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_vertical_nuap32_k$(false);
        goBackButton(get_centered(element_0));
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_2 = get_centered(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.h1' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_3 = weight(this_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextView())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_3.willAddChild_hz2iwc_k$(element_1);
        element_1.set_themeChoice_py59um_k$(element_1.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H1Semantic())));
        var tmp = KMutableProperty0();
        var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_1);
        var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_1));
        element_1.invoke_bnq13k_k$(tmp_1, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(this.grant_1).name_1);
        element_1.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_4 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !$this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        this_4.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_5 = themed(element_2, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = new (RowOrCol())(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        this_5.willAddChild_hz2iwc_k$(element_3);
        element_3.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (RowOrCol())(element_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        element_3.willAddChild_hz2iwc_k$(element_4);
        element_4.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_6 = get_centered(element_4);
        var tmp$ret$29 = weight(this_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_7 = get_bold(tmp$ret$29);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = new (TextView())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        this_7.willAddChild_hz2iwc_k$(element_5);
        var tmp_2 = KMutableProperty0();
        var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_5);
        var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_5));
        element_5.invoke_bnq13k_k$(tmp_4, GrantDetailPage$render$lambda);
        element_5.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_5);
        var tmp_5 = get_centered(element_4);
        var tmp_6 = shownWhen(tmp_5, false, VOID, GrantDetailPage$render$lambda_0);
        var tmp_7 = get_edit(Companion_getInstance_0());
        var tmp_8 = GrantDetailPage$render$lambda_1;
        iconButton(tmp_6, tmp_7, tmp_8, ($this$iconButton) => {
          onClick($this$iconButton, VOID, VOID, VOID, GrantDetailPage$render$lambda$slambda(this));
          return Unit_instance;
        });
        element_4.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_rem(50);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (RowCollapsingToColumn())(element_3.get_context_h02k06_k$(), listOf(new (Dimension())(breakpoint)));
        ensureOutermostElement(element_6);
        element_3.willAddChild_hz2iwc_k$(element_6);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_8 = weight(element_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        this_8.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(true);
        var tmp_9 = GrantDetailPage$render$lambda_2;
        maybeLabel(element_7, tmp_9, ($this$maybeLabel) => $this$maybeLabel.invoke_r7m7el_k$(this.grant_1).funder_1);
        var tmp_10 = GrantDetailPage$render$lambda_3;
        maybeLabel(element_7, tmp_10, ($this$maybeLabel) => $this$maybeLabel.invoke_r7m7el_k$(this.grant_1).activeRange_1.toString());
        element_7.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_7);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp_11 = weight(element_6, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_9 = shownWhen(tmp_11, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = new (RowOrCol())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_9.willAddChild_hz2iwc_k$(element_8);
        element_8.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (Separator())(element_8.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        element_8.willAddChild_hz2iwc_k$(element_9);
        element_9.onStartup_vrxh3i_k$();
        element_8.addChild_2qpft2_k$(element_9);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_10 = weight(element_8, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = new (RowOrCol())(this_10.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        this_10.willAddChild_hz2iwc_k$(element_10);
        element_10.set_vertical_nuap32_k$(true);
        var tmp_12 = shownWhen(element_10, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.grant_1).balance_1 == null);
        var tmp_13 = GrantDetailPage$render$lambda_4;
        reactiveLabel(tmp_12, tmp_13, ($this$reactiveLabel) => {
          var tmp0_safe_receiver = $this$reactiveLabel.invoke_r7m7el_k$(this.grant_1).balance_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.balance_1;
          var tmp;
          var tmp_0 = tmp1_safe_receiver;
          if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? $this$reactiveLabel.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantBalanceNotSynced_ef929w_k$() : tmp2_elvis_lhs;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_11 = themed(shownWhen(element_10, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.grant_1).balance_1 == null)), CompactSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (RowOrCol())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_11.willAddChild_hz2iwc_k$(element_11);
        element_11.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_12 = themed(element_11, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(this_12.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        this_12.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (TextView())(element_12.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        element_12.willAddChild_hz2iwc_k$(element_13);
        element_13.set_themeChoice_py59um_k$(element_13.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_14 = KMutableProperty0();
        var tmp_15 = TextView$_get_content_$ref_4pzcwl(element_13);
        var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, TextView$_set_content_$ref_pketfb(element_13));
        element_13.invoke_bnq13k_k$(tmp_16, GrantDetailPage$render$lambda_5);
        element_13.onStartup_vrxh3i_k$();
        element_12.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_13 = get_bold(themed(element_12, LargeTextSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (TextView())(this_13.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_13.willAddChild_hz2iwc_k$(element_14);
        var tmp_17 = KMutableProperty0();
        var tmp_18 = TextView$_get_content_$ref_4pzcwl(element_14);
        var tmp_19 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb(element_14));
        element_14.invoke_bnq13k_k$(tmp_19, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.grant_1).balance_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.balance_1;
          var tmp;
          var tmp_0 = tmp1_safe_receiver;
          if ((tmp_0 == null ? null : new (Cents())(tmp_0)) == null) {
            tmp = null;
          } else {
            tmp = Cents__toString_impl_ko5hxm(tmp1_safe_receiver);
          }
          var tmp2_elvis_lhs = tmp;
          return tmp2_elvis_lhs == null ? $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_grantBalanceNotSynced_ef929w_k$() : tmp2_elvis_lhs;
        });
        element_14.onStartup_vrxh3i_k$();
        this_13.addChild_2qpft2_k$(element_14);
        element_12.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (TextView())(element_11.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        element_11.willAddChild_hz2iwc_k$(element_15);
        element_15.set_themeChoice_py59um_k$(element_15.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_20 = KMutableProperty0();
        var tmp_21 = TextView$_get_content_$ref_4pzcwl(element_15);
        var tmp_22 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb(element_15));
        element_15.invoke_bnq13k_k$(tmp_22, ($this$invoke) => {
          var tmp0_safe_receiver = $this$invoke.invoke_r7m7el_k$(this.grant_1).balance_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.at_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : renderToString(tmp1_safe_receiver);
          return 'Last updated ' + (tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs);
        });
        element_15.onStartup_vrxh3i_k$();
        element_11.addChild_2qpft2_k$(element_15);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (RowOrCol())(element_11.get_context_h02k06_k$());
        ensureOutermostElement(element_16);
        element_11.willAddChild_hz2iwc_k$(element_16);
        element_16.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_14 = themed(element_16, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_17 = new (Link())(this_14.get_context_h02k06_k$());
        ensureOutermostElement(element_17);
        this_14.willAddChild_hz2iwc_k$(element_17);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_15 = themed(element_17, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_18 = new (RowOrCol())(this_15.get_context_h02k06_k$());
        ensureOutermostElement(element_18);
        this_15.willAddChild_hz2iwc_k$(element_18);
        element_18.set_vertical_nuap32_k$(false);
        text(get_centered(element_18), 'View ledger');
        // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
        var this_16 = get_centered(element_18);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_19 = new (IconView())(this_16.get_context_h02k06_k$());
        ensureOutermostElement(element_19);
        this_16.willAddChild_hz2iwc_k$(element_19);
        element_19.set_source_3o5lkf_k$(get_arrowForward(Companion_getInstance_0()).resize_q1xpz0_k$(get_rem(1)));
        var tmp_23 = KMutableProperty0();
        var tmp_24 = IconView$_get_description_$ref_x7iif6(element_19);
        var tmp_25 = getPropertyCallableRef('description', 0, tmp_23, tmp_24, IconView$_set_description_$ref_rpvc1e(element_19));
        element_19.invoke_bnq13k_k$(tmp_25, GrantDetailPage$render$lambda_6);
        element_19.onStartup_vrxh3i_k$();
        this_16.addChild_2qpft2_k$(element_19);
        element_18.onStartup_vrxh3i_k$();
        this_15.addChild_2qpft2_k$(element_18);
        var tmp_26 = KMutableProperty0();
        var tmp_27 = Link$_get_to_$ref_jq7esp(element_17);
        var tmp_28 = getPropertyCallableRef('to', 0, tmp_26, tmp_27, Link$_set_to_$ref_i9gu5x(element_17));
        element_17.invoke_bnq13k_k$(tmp_28, ($this$invoke) => () => new (GrantTransactionsPage())(this.id_1));
        element_17.onStartup_vrxh3i_k$();
        this_14.addChild_2qpft2_k$(element_17);
        element_16.onStartup_vrxh3i_k$();
        element_11.addChild_2qpft2_k$(element_16);
        element_11.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_11);
        element_10.onStartup_vrxh3i_k$();
        this_10.addChild_2qpft2_k$(element_10);
        element_8.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_8);
        element_6.onStartup_vrxh3i_k$();
        element_3.addChild_2qpft2_k$(element_6);
        element_3.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_17 = shownWhen(element_2, VOID, VOID, GrantDetailPage$render$lambda_7);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_20 = new (RowOrCol())(this_17.get_context_h02k06_k$());
        ensureOutermostElement(element_20);
        this_17.willAddChild_hz2iwc_k$(element_20);
        element_20.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_21 = new (Space())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_21);
        element_20.willAddChild_hz2iwc_k$(element_21);
        element_21.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_21);
        styledHeader(element_20, GrantDetailPage$render$lambda_8);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_22 = new (RowOrCol())(element_20.get_context_h02k06_k$());
        ensureOutermostElement(element_22);
        element_20.willAddChild_hz2iwc_k$(element_22);
        element_22.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_18 = themed(element_22, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_23 = new (Link())(this_18.get_context_h02k06_k$());
        ensureOutermostElement(element_23);
        this_18.willAddChild_hz2iwc_k$(element_23);
        text(element_23, 'Match by family');
        var tmp_29 = KMutableProperty0();
        var tmp_30 = Link$_get_to_$ref_jq7esp(element_23);
        var tmp_31 = getPropertyCallableRef('to', 0, tmp_29, tmp_30, Link$_set_to_$ref_i9gu5x(element_23));
        element_23.invoke_bnq13k_k$(tmp_31, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (DayTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          this_0.groupBy_1.set_value_v1vabv_k$(DayGrouping_Family_getInstance());
          return this_0;
        });
        element_23.onStartup_vrxh3i_k$();
        this_18.addChild_2qpft2_k$(element_23);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_19 = themed(element_22, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_24 = new (Link())(this_19.get_context_h02k06_k$());
        ensureOutermostElement(element_24);
        this_19.willAddChild_hz2iwc_k$(element_24);
        text(element_24, 'Enrollment');
        var tmp_32 = KMutableProperty0();
        var tmp_33 = Link$_get_to_$ref_jq7esp(element_24);
        var tmp_34 = getPropertyCallableRef('to', 0, tmp_32, tmp_33, Link$_set_to_$ref_i9gu5x(element_24));
        element_24.invoke_bnq13k_k$(tmp_34, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (PlacementTotalsPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          return this_0;
        });
        element_24.onStartup_vrxh3i_k$();
        this_19.addChild_2qpft2_k$(element_24);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.link' call
        var this_20 = themed(element_22, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_25 = new (Link())(this_20.get_context_h02k06_k$());
        ensureOutermostElement(element_25);
        this_20.willAddChild_hz2iwc_k$(element_25);
        text(element_25, 'Days funded');
        var tmp_35 = KMutableProperty0();
        var tmp_36 = Link$_get_to_$ref_jq7esp(element_25);
        var tmp_37 = getPropertyCallableRef('to', 0, tmp_35, tmp_36, Link$_set_to_$ref_i9gu5x(element_25));
        element_25.invoke_bnq13k_k$(tmp_37, ($this$invoke) => () => {
          // Inline function 'kotlin.apply' call
          var this_0 = new (SingleDaysPage())();
          this_0.filter_1.set_value_v1vabv_k$(new (ReportFilters())(VOID, VOID, VOID, setOf(new (ID())(this.id_1))));
          return this_0;
        });
        element_25.onStartup_vrxh3i_k$();
        this_20.addChild_2qpft2_k$(element_25);
        element_22.onStartup_vrxh3i_k$();
        element_20.addChild_2qpft2_k$(element_22);
        element_20.onStartup_vrxh3i_k$();
        this_17.addChild_2qpft2_k$(element_20);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_26 = new (Space())(element_2.get_context_h02k06_k$());
        ensureOutermostElement(element_26);
        element_2.willAddChild_hz2iwc_k$(element_26);
        element_26.onStartup_vrxh3i_k$();
        element_2.addChild_2qpft2_k$(element_26);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_21 = shownWhen(element_2, false, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.isAdmin_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_27 = new (RowOrCol())(this_21.get_context_h02k06_k$());
        ensureOutermostElement(element_27);
        this_21.willAddChild_hz2iwc_k$(element_27);
        element_27.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_28 = new (RowOrCol())(element_27.get_context_h02k06_k$());
        ensureOutermostElement(element_28);
        element_27.willAddChild_hz2iwc_k$(element_28);
        element_28.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var this_22 = get_atBottomStart(element_28);
        var tmp$ret$130 = weight(this_22, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_23 = themed(tmp$ret$130, LabelGapSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_29 = new (RowOrCol())(this_23.get_context_h02k06_k$());
        ensureOutermostElement(element_29);
        this_23.willAddChild_hz2iwc_k$(element_29);
        element_29.set_vertical_nuap32_k$(true);
        styledHeader(element_29, GrantDetailPage$render$lambda_9);
        // Inline function 'com.lightningkite.kiteui.views.direct.subtext' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_30 = new (TextView())(element_29.get_context_h02k06_k$());
        ensureOutermostElement(element_30);
        element_29.willAddChild_hz2iwc_k$(element_30);
        element_30.set_themeChoice_py59um_k$(element_30.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SubtextSemantic_getInstance()));
        var tmp_38 = KMutableProperty0();
        var tmp_39 = TextView$_get_content_$ref_4pzcwl(element_30);
        var tmp_40 = getPropertyCallableRef('content', 0, tmp_38, tmp_39, TextView$_set_content_$ref_pketfb(element_30));
        element_30.invoke_bnq13k_k$(tmp_40, GrantDetailPage$render$lambda_10);
        element_30.onStartup_vrxh3i_k$();
        element_29.addChild_2qpft2_k$(element_30);
        element_29.onStartup_vrxh3i_k$();
        this_23.addChild_2qpft2_k$(element_29);
        var tmp_41 = get_centered(element_28);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_24 = shownWhen(tmp_41, false, VOID, GrantDetailPage$render$lambda_11);
        var tmp_42 = themed(this_24, ImportantSemantic_getInstance());
        var tmp_43 = GrantDetailPage$render$lambda_12;
        addButton(tmp_42, tmp_43, ($this$addButton) => {
          $this$addButton.set_action_2ds022_k$(Action('Add new rate', VOID, VOID, VOID, VOID, VOID, GrantDetailPage$render$lambda$slambda_0($this$addButton, this)));
          return Unit_instance;
        });
        element_28.onStartup_vrxh3i_k$();
        element_27.addChild_2qpft2_k$(element_28);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_25 = shownWhen(element_27, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(this.currentRate_1) == null));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_31 = new (RowOrCol())(this_25.get_context_h02k06_k$());
        ensureOutermostElement(element_31);
        this_25.willAddChild_hz2iwc_k$(element_31);
        element_31.set_vertical_nuap32_k$(true);
        var current = get_waitForNotNull(this.currentRate_1);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_26 = themed(element_31, CardSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_32 = new (RowOrCol())(this_26.get_context_h02k06_k$());
        ensureOutermostElement(element_32);
        this_26.willAddChild_hz2iwc_k$(element_32);
        element_32.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_33 = new (RowOrCol())(element_32.get_context_h02k06_k$());
        ensureOutermostElement(element_33);
        element_32.willAddChild_hz2iwc_k$(element_33);
        element_33.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        var this_27 = themed(get_centered(element_33), ChipSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_28 = themed(this_27, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_34 = new (TextView())(this_28.get_context_h02k06_k$());
        ensureOutermostElement(element_34);
        this_28.willAddChild_hz2iwc_k$(element_34);
        var tmp_44 = KMutableProperty0();
        var tmp_45 = TextView$_get_content_$ref_4pzcwl(element_34);
        var tmp_46 = getPropertyCallableRef('content', 0, tmp_44, tmp_45, TextView$_set_content_$ref_pketfb(element_34));
        element_34.invoke_bnq13k_k$(tmp_46, GrantDetailPage$render$lambda_13);
        element_34.onStartup_vrxh3i_k$();
        this_28.addChild_2qpft2_k$(element_34);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_29 = weight(element_33, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_35 = new (Space())(this_29.get_context_h02k06_k$());
        ensureOutermostElement(element_35);
        this_29.willAddChild_hz2iwc_k$(element_35);
        element_35.onStartup_vrxh3i_k$();
        this_29.addChild_2qpft2_k$(element_35);
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        var this_30 = get_centered(element_33);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_36 = new (TextView())(this_30.get_context_h02k06_k$());
        ensureOutermostElement(element_36);
        this_30.willAddChild_hz2iwc_k$(element_36);
        var tmp_47 = KMutableProperty0();
        var tmp_48 = TextView$_get_content_$ref_4pzcwl(element_36);
        var tmp_49 = getPropertyCallableRef('content', 0, tmp_47, tmp_48, TextView$_set_content_$ref_pketfb(element_36));
        element_36.invoke_bnq13k_k$(tmp_49, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).rateInForceSince_kfs6_k$($this$invoke.invoke_r7m7el_k$(current).activeRange_1.toString()));
        element_36.onStartup_vrxh3i_k$();
        this_30.addChild_2qpft2_k$(element_36);
        element_33.onStartup_vrxh3i_k$();
        element_32.addChild_2qpft2_k$(element_33);
        var tmp2 = lens(current, GrantDetailPage$render$lambda_14);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaViewer' call
        var label = GrantDetailPage$render$lambda_15;
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_31 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
        var tmp$ret$166 = isInterface(this_31, KSerializer()) ? this_31 : THROW_CCE();
        var testValues = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$166));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_32 = serializer(createKType(getKClass(CareDayInfoWithEmployerSubsidy()), arrayOf([]), false));
        var tmp_50 = isInterface(this_32, KSerializer()) ? this_32 : THROW_CCE();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_33 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
        var tmp$ret$170 = isInterface(this_33, KSerializer()) ? this_33 : THROW_CCE();
        formulaViewer(element_32, tmp_50, tmp$ret$170, tmp2, label, testValues);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_37 = new (Space())(element_32.get_context_h02k06_k$());
        ensureOutermostElement(element_37);
        element_32.willAddChild_hz2iwc_k$(element_37);
        element_37.onStartup_vrxh3i_k$();
        element_32.addChild_2qpft2_k$(element_37);
        var tmp2_0 = lens(current, GrantDetailPage$render$lambda_16);
        // Inline function 'org.thecommunitygroupinc.cares.views.components.formulaViewer' call
        var label_0 = GrantDetailPage$render$lambda_17;
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_34 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
        var tmp$ret$176 = isInterface(this_34, KSerializer()) ? this_34 : THROW_CCE();
        var testValues_0 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(default_0(tmp$ret$176));
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_35 = serializer(createKType(getKClass(CareDayInfoWithSubsidies()), arrayOf([]), false));
        var tmp_51 = isInterface(this_35, KSerializer()) ? this_35 : THROW_CCE();
        // Inline function 'kotlinx.serialization.serializer' call
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_36 = serializer(createKType(PrimitiveClasses_getInstance().get_doubleClass_dahzcy_k$(), arrayOf([]), false));
        var tmp$ret$180 = isInterface(this_36, KSerializer()) ? this_36 : THROW_CCE();
        formulaViewer(element_32, tmp_51, tmp$ret$180, tmp2_0, label_0, testValues_0);
        element_32.onStartup_vrxh3i_k$();
        this_26.addChild_2qpft2_k$(element_32);
        element_31.onStartup_vrxh3i_k$();
        this_25.addChild_2qpft2_k$(element_31);
        var tmp_52 = GrantDetailPage$render$lambda_18;
        var tmp_53 = Companion_instance_0;
        var tmp_54 = GrantDetailPage$render$lambda_19;
        var tmp_55 = tmp_53.text$default_gwb2zv_k$(tmp_54, VOID, GrantDetailPage$render$lambda_20);
        var tmp_56 = Companion_instance_0;
        var tmp_57 = GrantDetailPage$render$lambda_21;
        var tmp_58 = tmp_56.custom_k0krgj_k$(tmp_57, 2.0, GrantDetailPage$render$lambda_22);
        var tmp_59 = Companion_instance_0;
        var tmp_60 = GrantDetailPage$render$lambda_23;
        table(element_27, this.rates_1, tmp_52, [tmp_55, tmp_58, tmp_59.custom_k0krgj_k$(tmp_60, 2.0, GrantDetailPage$render$lambda_24)]);
        element_27.onStartup_vrxh3i_k$();
        this_21.addChild_2qpft2_k$(element_27);
        element_2.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_37 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(this.editMode_1));
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_38 = new (RowOrCol())(this_37.get_context_h02k06_k$());
        ensureOutermostElement(element_38);
        this_37.willAddChild_hz2iwc_k$(element_38);
        element_38.set_vertical_nuap32_k$(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_39 = new (Separator())(element_38.get_context_h02k06_k$());
        ensureOutermostElement(element_39);
        element_38.willAddChild_hz2iwc_k$(element_39);
        element_39.onStartup_vrxh3i_k$();
        element_38.addChild_2qpft2_k$(element_39);
        actionBar(this, element_38);
        grantForm(this, element_38, this.grant_1, this.addEndDate_1, true);
        actionBar(this, element_38);
        // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_40 = new (Separator())(element_38.get_context_h02k06_k$());
        ensureOutermostElement(element_40);
        element_38.willAddChild_hz2iwc_k$(element_40);
        element_40.onStartup_vrxh3i_k$();
        element_38.addChild_2qpft2_k$(element_40);
        element_38.onStartup_vrxh3i_k$();
        this_37.addChild_2qpft2_k$(element_38);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_38 = shownWhen(element, VOID, VOID, GrantDetailPage$render$lambda_25);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_41 = new (Space())(this_38.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_41);
        this_38.willAddChild_hz2iwc_k$(element_41);
        element_41.onStartup_vrxh3i_k$();
        this_38.addChild_2qpft2_k$(element_41);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'GrantDetailPage', VOID, VOID, [Page(), CanBlockBack()]);
    GrantDetailPageClass = $;
  }
  return GrantDetailPageClass;
}
//region block: exports
export {
  GrantDetailPage as GrantDetailPage2hh4qttandzm4,
};
//endregion

//# sourceMappingURL=GrantDetailPage.mjs.map
